import { OptionGroupSearchParams } from './option-groups';

export const optionGroupsKeys = {
    root: ['searchOptionGroups'] as const,
    search: (options: OptionGroupSearchParams) => [...optionGroupsKeys.root, options] as const,
};
